import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatModule } from './mat-module';
import { GoNextDirective } from '../appDirectives/go-next.directive';
import { HttpClientModule } from '@angular/common/http';
import { PromptComponent } from '../includes/popups/prompt/prompt.component';
import { RouterModule } from '@angular/router';
import { UserInfoComponent } from '../includes/popups/user-info/user-info.component';
import { CustomSnackBarComponent } from '../utilities/custom-snack-bar/custom-snack-bar.component';
import { EditableFieldComponent } from '../utilities/editable-field/editable-field.component';
import { SharedModule } from '../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    GoNextDirective,
    UserInfoComponent,
    PromptComponent,
    CustomSnackBarComponent,
    EditableFieldComponent,
  ],
  imports: [
    CommonModule,
    MatModule,
    HttpClientModule,
    RouterModule,
    SharedModule,
  ],
  exports: [
    MatModule,
    GoNextDirective,
    UserInfoComponent,
    HttpClientModule,
    PromptComponent,
    CustomSnackBarComponent,
    RouterModule,
    EditableFieldComponent,
    SharedModule,
    TranslateModule,
  ],
  providers: [],
})
export class DesignUtilitiesModule {}
